import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FileUploadService } from '../../../services/file-upload.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CommonModule } from '@angular/common';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-documents-view',
  standalone: true,
  imports: [
    CommonModule,
    PdfViewerModule,
    ButtonModule,
    CardModule,
    ProgressSpinnerModule,
  ],
  template: `
    <div class="document-view-container">
      <!-- Spinner de Loading -->
      <div class="loading-container" *ngIf="isLoading">
        <p-progressSpinner styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
        <p class="loading-text">Carregando documento...</p>
      </div>

      <!-- Conteúdo do Documento -->
      <div class="content-container" *ngIf="uploadedImageUrl && !isLoading">
        @if(uploadedFileExtension !== 'pdf'){
          <img
            [src]="uploadedImageUrl"
            alt="Documento Selecionado"
            class="uploaded-image"
            (load)="onImageLoad()">
        } @else {
          <pdf-viewer
            [src]="uploadedImageUrl"
            [render-text]="true"
            class="pdf-viewer"
            (after-load-complete)="onImageLoad()">
          </pdf-viewer>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .document-view-container {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #f8f9fa;
      }

      .loading-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
      }

      .loading-text {
        color: #325565;
        font-size: 1rem;
        font-weight: 500;
        margin: 0;
      }

      :host ::ng-deep .custom-spinner .p-progress-spinner-circle {
        stroke: #F15A22;
      }

      .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1000;
        background-color: rgba(255, 255, 255, 0.9) !important;
        color: #325565 !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      }

      :host ::ng-deep .close-button:hover {
        background-color: #fff !important;
        color: #F15A22 !important;
      }

      .content-container {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        overflow: auto;
      }

      .uploaded-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .pdf-viewer {
        width: 100%;
        height: 100%;
        border: none;
      }

      @media (max-width: 768px) {
        .content-container {
          padding: 10px;
        }

        .close-button {
          top: 5px;
          right: 5px;
        }
      }
    `,
  ],
})
export class DocumentsViewComponent implements OnInit {
  uploadedImageUrl: string | null = null;
  uploadedFileExtension: string | undefined = '';
  isLoading: boolean = true;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fileUploadService: FileUploadService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const fileName = this.config.data.fileName;
    this.uploadedFileExtension = fileName.split('.').pop()?.toLowerCase();
    this.showUploadedImage(this.config.data.id);
  }

  showUploadedImage(id: number) {
    this.isLoading = true;
    this.fileUploadService.openView(id).subscribe({
      next: (fileBlob: Blob) => {
        this.uploadedImageUrl = URL.createObjectURL(fileBlob);
        // Timeout de segurança caso o evento de load não dispare
        setTimeout(() => {
          if (this.isLoading) {
            this.isLoading = false;
          }
        }, 3000);
      },
      error: (error) => {
        this.isLoading = false;
        alert('Erro ao carregar a imagem. Tente novamente.');
      },
    });
  }

  onImageLoad(): void {
    this.isLoading = false;
  }

  closeAndNavigate(): void {
    this.ref.close();
  }
}
